var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownvote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 5.83227H17.1134C17.4907 5.8256 17.8573 5.9577 18.1436 6.20348C18.43 6.44927 18.6161 6.79164 18.6667 7.16561V11.8323C18.6161 12.2062 18.43 12.5486 18.1436 12.7944C17.8573 13.0402 17.4907 13.1723 17.1134 13.1656H15.3334M10.6667 14.4989V17.1656C10.6667 17.696 10.8774 18.2047 11.2525 18.5798C11.6275 18.9549 12.1363 19.1656 12.6667 19.1656L15.3334 13.1656V5.83227H7.81335C7.4918 5.82864 7.17977 5.94134 6.93475 6.1496C6.68973 6.35787 6.52824 6.64767 6.48002 6.96561L5.56002 12.9656C5.53102 13.1567 5.5439 13.3518 5.59779 13.5374C5.65168 13.7231 5.74529 13.8947 5.87211 14.0406C5.99894 14.1864 6.15597 14.303 6.33231 14.3821C6.50864 14.4613 6.70008 14.5011 6.89335 14.4989H10.6667Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvote);
export default __webpack_public_path__ + "static/media/downvote.8208559e23d1371df6c73791a3079c4a.svg";
export { ForwardRef as ReactComponent };